"use client";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

// Keep the planner's action handlers beside its canvas state while showing
// their controls in the shared header on this route only.
export default function PlannerHeaderActions({ children }) {
  const [target, setTarget] = useState(null);
  useEffect(() => {
    setTarget(document.getElementById("planner-header-actions"));
  }, []);
  return target ? createPortal(children, target) : null;
}
